import axios from "./axios";
import url from "./url";



async function saveLog(name, description) {
  try {
    let user = localStorage.getItem("user.id");
    const response = await axios.post("/logs", {
      name,
      description,
      user,
    },{
      headers:{
        Authorization: `Bearer ${localStorage.getItem("user.token")}`
      }});
    return response.data;
  } catch (e) {
    console.log("Failed to log", e);
  }
}


export default saveLog;
